import Parse from 'html-react-parser';

function BMP20171(props) {
    let svgCode =
    `<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g fill="${props.fontColour}" stroke="${props.fontColour}">
            <line x1="13" y1="2" x2="13" y2="24" stroke-width="2"/>
            <line x1="23.0003" y1="13" x2="3.00028" y2="13.0059" stroke-width="2"/>
            <path d="M13 0L17.825 5.57143H8.17502L13 0Z" />
            <path d="M26 13L20.4286 17.825L20.4286 8.17499L26 13Z" />
            <path d="M-2.43535e-07 13L5.57143 8.17501L5.57143 17.825L-2.43535e-07 13Z" />
            <path d="M13 26L8.17498 20.4286L17.825 20.4286L13 26Z" />
        </g>
    </svg>`

    props.svgReturn(38, svgCode, "bmp00171", 26, 26);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20171;